import { gql } from '@apollo/client';

const QUERY_T3B_TICKET = gql`
    query T3B_TICKET($ticketId: String!, $storeId: String!, $posId: String!, $ticketDate: Date!) {
        t3bTicket(ticketId: $ticketId, storeId: $storeId, posId: $posId, ticketDate: $ticketDate) {
            ticketId
            ticketFound
            ticketTotalSale
            canRequest
            message
        }
    }
`;

export default QUERY_T3B_TICKET;
